import {history} from 'new-components/router/history';
import {put, takeEvery, throttle, select, putResolve, delay} from 'redux-saga/effects';
import {getCashpoints, getOldOrders, getRestaurantList} from 'new-actions/api.actions.ts';
import {OPEN_INITIAL, OPEN_ORDERS, OPEN_SELECT_LOCATION} from 'new-constants/popup.constants';
import {CHECKOUT} from 'new-constants/navigation.constants';
import {SET_ORDER_TYPE_INITIAL} from 'new-constants/ordering-mode.constants';
import {START} from 'new-constants/app-state.constants';
import {
	CHECK_PAYMENT_STATUS_SUCCESS,
	CHECK_PHONE_CODE_SUCCESS,
	SET_GUEST_SUCCESS,
	SET_PHONE_SUCCESS
} from "../constants/api.constants";
import {OPEN_ORDER} from "../constants/navigation.constants";
import {getHistoryOrders, getOrder} from "../actions/api.actions";
import {getCurrentAppIdSelector, getCurrentCashpointsSelector} from "../selectors";
import {getCartRoute, getOrderRoute} from "../helpers/routes.helper";
import {DONE_MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE} from "../constants/popup.constants";
import {PaymentStatuses} from "new-constants/common.constants";

function* refreshOldOrders() {
	yield put(getHistoryOrders());
}

function* refreshOldOrdersWithDelay() {
	yield delay(3000);

	yield put(getHistoryOrders());
}

function* refreshCashpoints() {
	const state = yield select();

	const currentCashpoints = getCurrentCashpointsSelector(state);

	const CacheLifetime = 10 * 1000;
	if(Math.abs(currentCashpoints.fetchedTimestamp - Date.now()) < CacheLifetime){
		return;
	}

	yield put(getCashpoints());
}

function* refreshCashpointsWithDelay() {
	yield delay(3000);

	const state = yield select();

	const currentCashpoints = getCurrentCashpointsSelector(state);

	const CacheLifetime = 10 * 1000;
	if(Math.abs(currentCashpoints.fetchedTimestamp - Date.now()) < CacheLifetime){
		return;
	}

	yield put(getCashpoints());
}

function* openCart() {
	history.push(getCartRoute());
}

function* refreshRestaurantList() {
	yield delay(1000);
	const state = yield select();
	yield putResolve(getRestaurantList(false));
}

function* initialRefreshRestaurantList() {
	yield delay(1000);
	const state = yield select();

	const currentAppId = getCurrentAppIdSelector(state);
	if(!currentAppId) return;

	yield putResolve(getRestaurantList(true));
}

function* hideSplash() {
	if (navigator.splashscreen) {
		navigator.splashscreen.hide();
	}
}

function* openAndRefreshOrder(action) {
	history.push(
		getOrderRoute(action.orderId)
	);

	yield delay(1000);
	yield put(getOrder(action.orderId));
}



export const navigationSaga = function* orderLineSaga() {
	yield takeEvery([OPEN_ORDERS, DONE_MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE], refreshOldOrders);
	yield takeEvery([CHECK_PHONE_CODE_SUCCESS], refreshOldOrdersWithDelay);
	yield takeEvery([OPEN_INITIAL], refreshCashpoints);
	yield takeEvery([START], refreshCashpointsWithDelay);
	yield takeEvery([CHECKOUT, SET_GUEST_SUCCESS], openCart);
	yield takeEvery(
		action => action.type === CHECK_PHONE_CODE_SUCCESS && action.payload.data.shouldOpenCartOnLogin,
		openCart
	);
	yield throttle(20000, [SET_ORDER_TYPE_INITIAL, OPEN_SELECT_LOCATION], refreshRestaurantList);
	yield takeEvery([START], initialRefreshRestaurantList);
	yield takeEvery(START, hideSplash);
	yield takeEvery(OPEN_ORDER, openAndRefreshOrder);

};
